var _g, _line, _g2, _text, _text2, _text3, _g3, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpNewCeilingToFloor3ArcNoRod(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "540px",
    height: "650px",
    viewBox: "0 0 540 650",
    enableBackground: "new 0 0 540 650",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    opacity: 0.8,
    fill: "#B2B2B2",
    stroke: "#717070",
    strokeWidth: 0.6174,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    points: " 450.5,111.2 460,101.6 0.3,101.6 9.2,111.2 449.2,111.2  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 69.5,
    fill: "#C6C6C6",
    stroke: "#717070",
    strokeWidth: 0.5848,
    strokeMiterlimit: 10,
    enableBackground: "new    ",
    width: 460,
    height: 32.1
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 2.9678,
    x1: 0,
    y1: 645,
    x2: 460,
    y2: 645
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M476.6,648v-13.3h8.7v1.5h-7.1v4.3h6.9v1.5h-6.9v6.1H476.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M487.4,648v-13.3h1.7v11.9h6.2v1.5H487.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M497.7,644.8c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9S498.3,645.9,497.7,644.8z M498.6,641.3c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S498.6,639.7,498.6,641.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M513,644.8c-0.5-1-0.8-2.2-0.8-3.5s0.3-2.5,0.8-3.5c0.5-1,1.3-1.9,2.3-2.5s2.2-0.9,3.5-0.9 c1.3,0,2.4,0.3,3.5,0.9c1,0.6,1.8,1.4,2.4,2.5s0.8,2.2,0.8,3.5s-0.3,2.5-0.8,3.5s-1.3,1.9-2.4,2.5c-1,0.6-2.2,0.9-3.5,0.9 c-1.3,0-2.4-0.3-3.5-0.9S513.6,645.9,513,644.8z M513.9,641.3c0,1,0.2,2,0.6,2.8c0.4,0.8,1,1.5,1.7,1.9s1.6,0.7,2.6,0.7 s1.8-0.2,2.6-0.7s1.3-1.1,1.7-1.9s0.6-1.7,0.6-2.8c0-1.6-0.5-2.9-1.4-3.9c-0.9-1-2.1-1.5-3.6-1.5c-1.5,0-2.7,0.5-3.6,1.5 S513.9,639.7,513.9,641.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#464545",
    d: "M528,648v-13.3h5.4c1.2,0,2.2,0.4,3,1.1s1.2,1.7,1.2,2.9c0,0.6-0.1,1.1-0.3,1.6c-0.2,0.5-0.5,0.9-0.8,1.2 c-0.3,0.3-0.7,0.6-1.1,0.8c-0.4,0.2-0.9,0.3-1.3,0.3l3.6,5.4h-2l-3.4-5.3h-2.7v5.3H528z M529.7,641.2h3.5c0.8,0,1.4-0.2,1.9-0.7 c0.5-0.5,0.8-1.1,0.8-1.8s-0.2-1.4-0.7-1.8s-1.1-0.7-1.9-0.7h-3.5V641.2z"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 131.296 23.338)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 26
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 221.8246 23.338)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 26
  }, "B")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 312.4214 23.338)",
    fill: "#464545",
    fontFamily: "'ProximaNova-Regular'",
    fontSize: 26
  }, "C")), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 89.9,
    y: 176.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 280.2,
    height: 389
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 199.5,
    fill: "none",
    stroke: "#616261",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    width: 234,
    height: 342.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 320.7,
    y1: 82.4,
    x2: 320.7,
    y2: 632
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.7,85 320.7,69.5 329.7,85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "311.7,629.4 320.7,645 329.7,629.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 229.5,
    y1: 82.4,
    x2: 229.5,
    y2: 632
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.5,85 229.5,69.5 238.4,85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "220.5,629.4 229.5,645 238.4,629.4  "
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#464545",
    strokeWidth: 3,
    x1: 139.3,
    y1: 82.4,
    x2: 139.3,
    y2: 632
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.3,85 139.3,69.5 148.3,85  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    fill: "#464545",
    points: "130.3,629.4 139.3,645 148.3,629.4  "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpNewCeilingToFloor3ArcNoRod);
export default __webpack_public_path__ + "static/media/help_new_ceiling_to_floor_3_arc_noRod.c81ac604d900ea1f610ca36872144bf5.svg";
export { ForwardRef as ReactComponent };